<template>
  <div class="at-empty-conversation">
      <i :class="listIcon"></i>
      <span v-if="isSidebarProps">{{no_results}}</span>
      <span v-else>{{start_conv}}</span>
    </div>
</template>

<script>
import { GUPPYCHAT_TRANSLATION as translation } from "../../resources/constants"
export default {
  name : "EmptyView",
  props:['isSidebarProps', 'listIcon'],
  data(){
    return {
      start_conv : translation.start_conversation,
      no_results : translation.no_results
    }
  }
}
</script>

<style>
.at-empty-conversation {
  text-align: center;
  background-color: #F7F7F7;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.at-empty-conversation i {
  color: var(--primguppycolor);
  font-size: 52px;
  display: block;
  margin-bottom: 20px;
}
.at-empty-conversation span {
  color: var(--terguppycolor);
  display: block;
  font: 500 24px/40px var(--primchatfont);
}
</style>